import seedCurrentEn from './orion_current.en.json';

export default {
  ...seedCurrentEn,
};
